import { RiskLevelBarVariantType } from '../../../../../../components/riskLevelBar/types/riskLevelBarVariantType';
import { FONT_WEIGHT } from '../../../foundations/typography';
import { TextVariantType } from '../../text/variants';
export const getRegularStyles = (FOUNDATIONS, FONT) => {
    return {
        [RiskLevelBarVariantType.REGULAR]: {
            rootContainer: {
                width: '100%',
                display: 'flex',
                flex_direction: 'column',
                gap: FOUNDATIONS.spacing_50,
                min_width: FOUNDATIONS.size_1180,
            },
            title: {
                font_variant: TextVariantType.FONT_PARAGRAPH_550,
                font_weight: FONT_WEIGHT.font_weight_600,
                color: FOUNDATIONS.color_comp_legal_risklevelbar_font,
            },
            labelsScaleContainer: {
                display: 'flex',
                flex_direction: 'column',
                gap: FOUNDATIONS.spacing_150,
            },
            topLabelsContainer: {
                display: 'flex',
                flex_direction: 'row',
                gap: FOUNDATIONS.spacing_150,
                justify_content: 'space-between',
            },
            leftTopLabel: {
                font_variant: TextVariantType.FONT_PARAGRAPH_650,
                font_weight: FONT_WEIGHT.font_regular,
                color: FOUNDATIONS.color_comp_legal_risklevelbar_font,
            },
            rightTopLabel: {
                font_variant: TextVariantType.FONT_PARAGRAPH_650,
                font_weight: FONT_WEIGHT.font_regular,
                color: FOUNDATIONS.color_comp_legal_risklevelbar_font,
                text_align: 'right',
            },
            scaleBottomLabelsContainer: {
                display: 'flex',
                flex_direction: 'column',
                gap: FOUNDATIONS.spacing_100,
            },
            scaleContainer: {
                display: 'flex',
                align_items: 'center',
                justify_content: 'space-between',
                border_radius: FOUNDATIONS.radius_100,
                background_color: FOUNDATIONS.color_comp_legal_risklevelbar_container_default_bg,
            },
            scaleElement: {
                SELECTED: {
                    container: {
                        display: 'flex',
                        padding: FOUNDATIONS.spacing_100,
                        justify_content: 'center',
                        align_items: 'center',
                        border_radius: FOUNDATIONS.radius_100,
                        background_color: FOUNDATIONS.color_neutral_bg_static_50,
                        flex_basis: '0',
                        flex_grow: '1',
                    },
                    text: {
                        font_variant: TextVariantType.FONT_PARAGRAPH_400,
                        font_weight: FONT_WEIGHT.font_regular,
                        color: FOUNDATIONS.color_neutral_font_static_white,
                    },
                },
                UNSELECTED: {
                    container: {
                        display: 'flex',
                        padding: FOUNDATIONS.spacing_100,
                        justify_content: 'center',
                        align_items: 'center',
                        border_radius: FOUNDATIONS.radius_100,
                        flex_basis: '0',
                        flex_grow: '1',
                    },
                    text: {
                        font_variant: TextVariantType.FONT_PARAGRAPH_350,
                        font_weight: FONT_WEIGHT.font_regular,
                        color: FOUNDATIONS.color_comp_legal_risklevelbar_number_default_font,
                    },
                },
            },
            emptyScaleContainer: {
                display: 'flex',
                justify_content: 'center',
                align_items: 'center',
                padding: FOUNDATIONS.spacing_100,
                border_radius: FOUNDATIONS.radius_100,
                border: `${FOUNDATIONS.border_50} solid ${FOUNDATIONS.color_comp_legal_risklevelbar_container_border}`,
            },
            feedbackMessage: {
                font_variant: TextVariantType.FONT_PARAGRAPH_350,
                font_weight: FONT_WEIGHT.font_regular,
                color: FOUNDATIONS.color_comp_legal_risklevelbar_font,
                text_align: 'center',
            },
            bottomLabelsContainer: {
                display: 'flex',
                flex_direction: 'row',
                gap: FOUNDATIONS.spacing_150,
                justify_content: 'space-between',
            },
            leftBottomLabel: {
                font_variant: TextVariantType.FONT_PARAGRAPH_650,
                font_weight: FONT_WEIGHT.font_regular,
                color: FOUNDATIONS.color_comp_legal_risklevelbar_font,
            },
            rightBottomLabel: {
                font_variant: TextVariantType.FONT_PARAGRAPH_650,
                font_weight: FONT_WEIGHT.font_regular,
                color: FOUNDATIONS.color_comp_legal_risklevelbar_font,
                text_align: 'right',
            },
        },
    };
};
//# sourceMappingURL=regular.js.map